import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { TrackDetailsGetAPI } from "../../../../../Helper/Redux/CitizenRegistrationSlice/GrievanceStatusSlice";
import { useEffect } from "react";
import moment from "moment";
import { createPortal } from "react-dom";
import "../../../../../theme/amchi-theme.css"

export default function TrackPopup(props) {

    const { handleTrackDetails, Title, handleFeedback, Flag, ModalData, ScreenName1 } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID, IndicatorGrievanceAreaID } = userDetails

    useEffect(() => {
        const data = {
            T_GrievanceRegistrationID: ModalData.RowData.t_GrievanceRegistrationID,
            M_UserID: UserID,
            token: token,

        }
        dispatch(TrackDetailsGetAPI({ data }))
    }, [])

    const { TableData, isLoading } = useSelector(state => state.TrackDetailsGetData)

    const handleClose = () => handleTrackDetails(false)

    return createPortal(
        <div className="am-page am-modal-backdrop" role="dialog" aria-modal="true">
            <div className="am-modal am-modal--lg">
                <div className="am-modal-head">
                    <span className="am-login-avatar"><i className="fa-solid fa-route"></i></span>
                    <h2>{t('GrievanceStatus.Track')}</h2>
                    <p>तक्रारीच्या कार्यवाहीचा प्रवास</p>

                    <button
                        type="button"
                        className="am-modal-close"
                        aria-label="Close"
                        onClick={handleClose}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <div className="am-modal-body">
                    {
                        isLoading ?
                            <div className="am-empty" style={{ marginBottom: 0 }}>
                                <i className="fa-solid fa-circle-notch fa-spin"></i>
                                <span>माहिती घेत आहे...</span>
                            </div>
                            :
                            TableData && TableData.length > 0 ?
                                <ol className="am-track">
                                    {
                                        TableData.map((i, index) => (
                                            <li className="am-track-step" key={index}>
                                                <span className="am-track-dot">
                                                    <i className="fa-solid fa-check"></i>
                                                </span>
                                                <div className="am-track-card">
                                                    <b>{i?.lableName ? i.lableName : '-'}</b>
                                                    <div className="am-track-meta">
                                                        <span>
                                                            <i className="fa-solid fa-user-tie"></i>
                                                            {i.designationName ? i.designationName : '-'}
                                                        </span>
                                                        <span>
                                                            <i className="fa-regular fa-calendar"></i>
                                                            {i.date ? moment(i.date).format('DD-MM-YYYY') : '-'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ol>
                                :
                                <div className="am-empty" style={{ marginBottom: 0 }}>
                                    <i className="fa-regular fa-folder-open"></i>
                                    <span>
                                        <b>तपशील उपलब्ध नाही</b>
                                        <span>या तक्रारीची कार्यवाही नोंद अद्याप उपलब्ध नाही.</span>
                                    </span>
                                </div>
                    }

                    <div className="am-form-actions" style={{ margin: '20px 0 0' }}>
                        <button type="button" className="am-btn am-btn--primary" onClick={handleClose}>
                            <i className="fa-solid fa-xmark"></i> बंद करा
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    )
}
